import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LiveTVPage from "../pages/live/page";
import NewsPage from "../pages/news/page";
import NewsArticlePage from "../pages/news/ArticlePage";
import ProgramsPage from "../pages/programs/page";
import ProgramDetailPage from "../pages/programs/DetailPage";
import VideosPage from "../pages/videos/page";
import VideoDetailPage from "../pages/videos/DetailPage";
import SchedulePage from "../pages/schedule/page";
import EntertainmentPage from "../pages/entertainment/page";
import SportsPage from "../pages/sports/page";
import ReligionPage from "../pages/religion/page";
import PhotoStudioPage from "../pages/photo-studio/page";
import ProductionPage from "../pages/production/page";
import GalleryPage from "../pages/gallery/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import AdvertsPage from "../pages/adverts/page";
import AdvertisePage from "../pages/advertise/page";
import CareersPage from "../pages/careers/page";
import DirectPage from "../pages/direct/page";
import PartnersPage from "../pages/partners/page";
import PrivacyPage from "../pages/legal/PrivacyPage";
import TermsPage from "../pages/legal/TermsPage";
import CookiesPage from "../pages/legal/CookiesPage";
import DisclaimerPage from "../pages/legal/DisclaimerPage";

import AdminLoginPage from "../pages/admin/LoginPage";
import AdminResetPasswordPage from "../pages/admin/ResetPasswordPage";
import AdminDashboardPage from "../pages/admin/DashboardPage";
import AdminRequireAuth from "../pages/admin/RequireAuth";
import AdminLayout from "../pages/admin/components/AdminLayout";
import NewsroomPage from "../pages/admin/news/NewsroomPage";
import ArticleEditorPage from "../pages/admin/news/ArticleEditorPage";
import LiveTvControlPage from "../pages/admin/live/LiveTvControlPage";
import MessagesPage from "../pages/admin/MessagesPage";

import {
  ProgramsAdminPage,
  ScheduleAdminPage,
  DirectAdminPage,
  SportsAdminPage,
  EntertainmentAdminPage,
  ReligionAdminPage,
  PhotoStudioAdminPage,
  ProductionAdminPage,
  PagesAdminPage,
  CareersAdminPage,
  AdvertisingAdminPage,
  PartnersAdminPage,
  NewsletterAdminPage,
  SeoAdminPage,
  AdvertsAdminPage,
} from "../pages/admin/crudPages";

import VideosAdminPage from "../pages/admin/VideosAdminPage";
import GalleryAdminPage from "../pages/admin/GalleryAdminPage";
import BreakingNewsAdminPage from "../pages/admin/BreakingNewsAdminPage";
import SiteSettingsPage from "../pages/admin/SiteSettingsPage";
import SocialMediaPage from "../pages/admin/SocialMediaPage";

import {
  SecurityAdminPage,
  ActivityAdminPage,
  SystemStatusAdminPage,
  AnalyticsAdminPage,
  MediaLibraryAdminPage,
  HomepageAdminPage,
  HelpAdminPage,
} from "../pages/admin/SystemPages";
import UsersAdminPage from "../pages/admin/UsersAdminPage";
import EmailBroadcastPage from "../pages/admin/EmailBroadcastPage";
import ProgramRemindersPage from "../pages/admin/ProgramRemindersPage";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/live", element: <LiveTVPage /> },
  { path: "/news", element: <NewsPage /> },
  { path: "/news/:slug", element: <NewsArticlePage /> },
  { path: "/programs", element: <ProgramsPage /> },
  { path: "/programs/:slug", element: <ProgramDetailPage /> },
  { path: "/videos", element: <VideosPage /> },
  { path: "/videos/:slug", element: <VideoDetailPage /> },
  { path: "/schedule", element: <SchedulePage /> },
  { path: "/entertainment", element: <EntertainmentPage /> },
  { path: "/sports", element: <SportsPage /> },
  { path: "/religion", element: <ReligionPage /> },
  { path: "/photo-studio", element: <PhotoStudioPage /> },
  { path: "/production", element: <ProductionPage /> },
  { path: "/gallery", element: <GalleryPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/adverts", element: <AdvertsPage /> },
  { path: "/advertise", element: <AdvertisePage /> },
  { path: "/careers", element: <CareersPage /> },
  { path: "/direct", element: <DirectPage /> },
  { path: "/partners", element: <PartnersPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/cookies", element: <CookiesPage /> },
  { path: "/disclaimer", element: <DisclaimerPage /> },

  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/admin/reset-password", element: <AdminResetPasswordPage /> },
  {
    path: "/admin",
    element: <AdminRequireAuth />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="/admin/dashboard" replace /> },
          { path: "dashboard", element: <AdminDashboardPage /> },
          { path: "live", element: <LiveTvControlPage /> },
          { path: "news", element: <NewsroomPage /> },
          { path: "news/new", element: <ArticleEditorPage /> },
          { path: "news/edit/:id", element: <ArticleEditorPage /> },
          { path: "videos", element: <VideosAdminPage /> },
          { path: "direct", element: <DirectAdminPage /> },
          { path: "programs", element: <ProgramsAdminPage /> },
          { path: "schedule", element: <ScheduleAdminPage /> },
          { path: "breaking", element: <BreakingNewsAdminPage /> },
          { path: "entertainment", element: <EntertainmentAdminPage /> },
          { path: "sports", element: <SportsAdminPage /> },
          { path: "religion", element: <ReligionAdminPage /> },
          { path: "photo-studio", element: <PhotoStudioAdminPage /> },
          { path: "production", element: <ProductionAdminPage /> },
          { path: "gallery", element: <GalleryAdminPage /> },
          { path: "media", element: <MediaLibraryAdminPage /> },
          { path: "homepage", element: <HomepageAdminPage /> },
          { path: "pages", element: <PagesAdminPage /> },
          { path: "social", element: <SocialMediaPage /> },
          { path: "advertising", element: <AdvertisingAdminPage /> },
          { path: "adverts", element: <AdvertsAdminPage /> },
          { path: "careers", element: <CareersAdminPage /> },
          { path: "newsletter", element: <NewsletterAdminPage /> },
          { path: "broadcast", element: <EmailBroadcastPage /> },
          { path: "reminders", element: <ProgramRemindersPage /> },
          { path: "messages", element: <MessagesPage /> },
          { path: "analytics", element: <AnalyticsAdminPage /> },
          { path: "seo", element: <SeoAdminPage /> },
          { path: "users", element: <UsersAdminPage /> },
          { path: "security", element: <SecurityAdminPage /> },
          { path: "activity", element: <ActivityAdminPage /> },
          { path: "system", element: <SystemStatusAdminPage /> },
          { path: "settings", element: <SiteSettingsPage /> },
          { path: "partners", element: <PartnersAdminPage /> },
          { path: "help", element: <HelpAdminPage /> },
        ],
      },
    ],
  },

  { path: "*", element: <NotFound /> },
];

export default routes;